<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-fill-play-arrow`]" width="1em" height="1em" v-bind="$attrs"><path d="M17.533 10.974a1 1 0 00-1.537.844v24.357a1 1 0 001.537.843L36.67 24.84a1 1 0 000-1.688L17.533 10.974z"/></svg>
</template>
<script>

export default {
  name: 'IconFillPlayArrow',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
